import Vue from "vue";
import Vuetify from "vuetify/lib";
//import "vuetify/src/stylus/app.styl";
import 'vuetify/dist/vuetify.min.css'
import "../theme/style.styl";
Vue.use(Vuetify);


// Translation provided by Vuetify (typescript)
import pt from 'vuetify/src/locale/pt.ts'
import en from 'vuetify/src/locale/en.ts'


export default new Vuetify({
  lang: {
    locales: {pt, en},
    current: 'pt',
  },
  theme: {
    themes : {
      light : {
        // primary: "#ee44aa",
        // secondary: "#424242",
        // accent: "#82B1FF",
        // error: "#FF5252",
        // info: "#2196F3",
        // success: "#4CAF50",
        // warning: "#FFC107"
      }
    }
  },
  customProperties: true,
  icons: {
    iconfont: 'fa4'
  }
})